require('../../modules/es.number.is-nan');

module.exports = require('../../internals/path').Number.isNaN;
